import { useState, useEffect } from 'react';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import { _BudgetAccountantMovement, _SubMacroProcess } from '../../../../../core/services/dataBean/EntityCatalog';
import { toast } from 'react-toastify';


interface Props {
    idBudgetAccountantOperation: any;
    idSelector: number;
    onChange: any;
    label?: string;
}

export const SelectAccountanMovement = ({ idSelector, idBudgetAccountantOperation, onChange, label }: Props) => {

    const { lista, setLista, bean, setBean, instance, deleteItemVoid, handleChange } = useDataBean(_BudgetAccountantMovement);
    // const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(null);

    useEffect(() => {
        if (idSelector >= 0) {
            setID(idSelector)
        }
    }, [])

    useEffect(() => {
        getLista();
    }, [idBudgetAccountantOperation])

    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }

    const getLista = () => {
        instance.getBudgetAccountantMovementCatalog(idBudgetAccountantOperation).then(
            (resp) => {
                setLista(resp);
            }
        ).catch(
            err => { toast.error(err) }
        )
    }
    return (
        <>
            <label>{label ?? "AccountanMovement"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={null}>...</option>

                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDBudgetAccountantMovement} >
                                {item.DataBeanProperties.Code} - {item.DataBeanProperties.Name}
                                </option>
                        )
                    })
                }
            </select>
        </>
    )
}